import { render, staticRenderFns } from "./PaglieraniContactPricing.vue?vue&type=template&id=a35d2942&scoped=true&"
import script from "./PaglieraniContactPricing.vue?vue&type=script&lang=js&"
export * from "./PaglieraniContactPricing.vue?vue&type=script&lang=js&"
import style0 from "./PaglieraniContactPricing.vue?vue&type=style&index=0&id=a35d2942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d2942",
  null
  
)

export default component.exports